import { Loader } from 'google-maps';
// import appConfig from '../app_config';
// console.log('language', navigator.language)
const options = {
  libraries: ['places'], language: 'en-us',
};
export default new Loader(process.env.VUE_APP_GOOGLE_MAP_API_KEY, options);
